import { useOffline } from '../components/App/AppOfflineContext'
import { useTenantContext } from '../components/App/AppTenant'
import MainLayout, { useMainLayoutContext } from '../components/MainLayout'
import EqxAlert from '../shared/components/EqxAlert/EqxAlert'
import EqxCard from '../shared/components/EqxCard/EqxCard'
import Tile from '../shared/components/EqxTile/EqxTile'
import TileGroup from '../shared/components/EqxTile/EqxTileGroup'

// Extracted inner component so it can access MainLayout context
const HRTileContent = () => {
    const { isOffline, isFileCached } = useOffline();
    const tenant = useTenantContext();
    const { user, permissions } = useMainLayoutContext();
    const hasStaffID = user?.staffID ? true : false;
    const canClockInOut = permissions?.canClockInOut;

    const disabledTraining = isOffline && !isFileCached('/training-records');
    const disabledAbsences = (isOffline && !(isFileCached('/absences/holiday-entitlements') || isFileCached('/absences/unassigned'))) || !permissions?.canBookAbsence;
    const disabledTimelog = isOffline && !isFileCached('/timelog/get-status');
    const disabledPayslips = (isOffline && !isFileCached('/payslips')) || !permissions?.canViewPayslips;
    const disabledExpenses = (isOffline && !(isFileCached('/additional-payments/pending') || isFileCached('/additional-payments/processed'))) || !permissions?.canAddExpenses;

    if (!hasStaffID) {
        return (
            <EqxAlert variant="danger" icon="fas fa-triangle-exclamation">
                You don't have access because you are not a member of staff for this organisation.
            </EqxAlert>
        );
    }

    return (
        <>
            <EqxCard isSection={true}>
                <div className="d-flex">
                    <div className="text-md-end mt-2 mt-md-0 me-2">
                        <div className="avatar-container">
                            <img src={user?.avatar} className="avatar" height="50" />
                        </div>
                    </div>
                    <div className="flex-grow-1 ps-2">
                        <h5 className="mb-0">{user?.name}</h5>
                        <div className="text-muted">{user?.email}</div>
                    </div>
                </div>
            </EqxCard>
            <TileGroup size="xs">

                {hasStaffID && (
                    <Tile
                        className="col-6 col-lg-4"
                        link="/training-records"
                        title="Training Records"
                        icon="tile-icon fas fa-trophy"
                        disabled={disabledTraining}
                    />
                )}

                {hasStaffID && canClockInOut && (
                    <Tile
                        className="col-6 col-lg-4"
                        link="/timelog"
                        title="Timelog"
                        icon="fas fa-clock"
                        disabled={disabledTimelog}
                    />
                )}

                {hasStaffID && (
                    <Tile
                        className="col-6 col-lg-4"
                        link="/absences"
                        title="Absences"
                        icon="fas fa-calendar-alt"
                        disabled={disabledAbsences}
                    />
                )}

                {tenant?.isManagedPayroll && hasStaffID && (
                    <Tile
                        className="col-6 col-lg-4"
                        link="/payslips"
                        title="Payslips"
                        icon="fas fa-money-bill-wave"
                        disabled={disabledPayslips}
                    />
                )}

                {tenant?.isManagedPayroll && hasStaffID && (
                    <Tile
                        className="col-6 col-lg-4"
                        link="/expenses"
                        title="Expenses"
                        icon="fas fa-plus-circle"
                        disabled={disabledExpenses}
                    />
                )}
            </TileGroup>
        </>
    );
}

interface PageHRProps { }
const PageHR = function (props: PageHRProps) {
    return (
        <MainLayout pageTitle="HR">
            <HRTileContent />
        </MainLayout>
    )
}

export { PageHR as default }


